module.exports = __webpack_public_path__ + "static/img/logo.b703f8db.png";